import React from 'react';
import Invest from '../components/works/Invest';
import Hero from '../components/works/Hero';
import Note from '../components/works/Note';

const Works = () => {
  return (
    <>
      <Hero />
      <Invest />
      <Note />
    </>
  );
};

export default Works;
